module.exports = __webpack_public_path__ + "static/Antonella_Carluccio-727bab6e992934ff637e125628d69135.jpg";